var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm:bg-none bg-[#d6fcf9a1] min-h-[100vh]"},[_c('GradientBg'),_c('notification'),_c('div',{staticClass:"h-full relative z-2"},[_c('Sidebar'),_c('Navbar'),_c('div',{staticClass:"lg:ml-[309px] ml-0 mt-[60px]"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }